import React, { useState, useEffect } from 'react';
//import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Modal,
} from 'reactstrap';
import SelectInput, { components } from 'react-select';
import { DatetimePicker } from '../../../commons/controls';
import Services from '../services';
import _ from 'lodash';
import RFField from '../../../components/Form/RFField';
import RFForm from '../../../components/Form/RFForm';
import TimeFormatter from '../../../commons/TimeFormatter';
import ProgressButton from '../../../commons/ProgressButton';

const ROW_STYLE = {marginBottom: '15px'};

const PartnerForm = props => {

  const {
    modositas,
    aktivalas,
    formKartyaTipus,
    formHelyszin,
    onRowSelect,
    setPartnerResponse,
    toggleShowTulajdonosForm,
    telefonTipusOptions,
    orszagHivoOptions,
  } = props;

  const [formTitulus, setTitulus] = useState('');
  const [formVezeteknev, setVezeteknev] = useState('');
  const [formKeresztnev, setKeresztnev] = useState('');
  const [formSzuletesnap, setSzuletesnap] = useState(null);
  const [formEmail, setEmail] = useState('');
  const [formTelefonTipus, setTelefonTipus] = useState('');
  const [formOrszagHivo, setOrszagHivo] = useState('');
  const [formTelefonszam, setTelefonszam] = useState('');
  const [loading, setLoading] = useState(false);

  const savePartner = () => {
    let submitObj = {};
    setLoading(true);

    submitObj.kartyaTipusId = formKartyaTipus && formKartyaTipus.id;
    submitObj.helyszinId = formHelyszin && formHelyszin.id;
    submitObj.titulus = formTitulus;
    submitObj.vezeteknev = formVezeteknev;
    submitObj.keresztnev = formKeresztnev;
    submitObj.szuletesnap = formSzuletesnap ? TimeFormatter.formatDate(formSzuletesnap) : null;
    submitObj.email = formEmail;
    submitObj.orszaghivo = formOrszagHivo && formOrszagHivo.name;
    submitObj.telefontipus = formTelefonTipus;
    submitObj.telefonszam = formTelefonszam;

    Services.insertPartnerBase(submitObj, (err, res) => {
      setLoading(false);
      if (!err) {
        toggleShowTulajdonosForm(false);
        onRowSelect({id: res[0].ptId}, true);
        setPartnerResponse(res[0]);
      }
    });
  }

  const Option = ({ children, ...props }) => {
      const { onMouseMove, onMouseOver, ...rest } = props.innerProps;
      const newProps = Object.assign(props, { innerProps: rest });
      return (
        <components.Option
          {...newProps}
        >
          <div className="flag-format" onClick={() => setOrszagHivo(props.data.num)}>
            <span
              className={'flag-icon flag-icon-' + props.data.name.toLowerCase()}
            />
            <b style={{ paddingLeft: ' 5px'}}>{props.data.caption}</b>
            {' '}
            +
            {props.data.num}
          </div>
        </components.Option>
      );
    };

  const isVisibleTulajdonos = (input) => {
    return formKartyaTipus && formKartyaTipus[input] && formKartyaTipus[input].name !== 'NEM_JELENIK';
  }

  const isRequiredTulajdonos = (input) => {
    return formKartyaTipus && formKartyaTipus[input].name === 'KOTELEZO';
  }

  const isDisabledTulajdonos = () => {
    return modositas && !aktivalas;
  }

  const renderForm = () => {
    return (
      <React.Fragment>
        <div className="row" style={ROW_STYLE}>
          <div className="col-md-3">
            <RFField
              label="Titulus: "
              name={"formTitulus"}
              value={formTitulus}
              onChange={(e,v) => setTitulus(v)}
              />
          </div>
          <div className="col-md-3">
            <RFField
              label="Vezetéknév: "
              name={"formVezeteknev"}
              value={formVezeteknev}
              onChange={(e,v) => setVezeteknev(v)}
              required
              />
          </div>
          <div className="col-md-3">
            <RFField
              label="Keresztnév: "
              name={"formKeresztnev"}
              value={formKeresztnev}
              onChange={(e,v) => setKeresztnev(v)}
              required
            />
          </div>
          {isVisibleTulajdonos("szuletesnap") && (
            <div className="col-md-3">
              <DatetimePicker
                label={'Születésnap: '}
                id={"formSzuletesnap"}
                name={"formSzuletesnap"}
                containerClassName="organw-date-time"
                time={false}
                // format="YYYY-MM-DD"
                messages={{ dateButton: "dátum", timeButton: "idő" }}
                onChange={(e,v) => setSzuletesnap(v)}
                value={formSzuletesnap && new Date(formSzuletesnap)}
                //disabled={isDisabledTulajdonos()}
                required={isRequiredTulajdonos("szuletesnap")}
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-md-12" style={{paddingRight: '2px'}}>
            <h5>Elérhetőség</h5>
          </div>
        </div>
        <div className="row" style={ROW_STYLE}>
          {isVisibleTulajdonos("telefon") && (
            <React.Fragment>
              <div className="col-md-4">
                <RFField
                  type="select"
                  name="formTelefonTipus"
                  id="formTelefonTipus"
                  label="Telefon típus:"
                  value={formTelefonTipus}
                  onChange={(e, v) => setTelefonTipus(e.target.value)}
                  errorMessage="Kötelező mező!"
                  defaultSelect={<option key="null" value={''}>Válassz opciót...</option>}
                  selectOptions={telefonTipusOptions}
                />
              </div>
              <div className="col-md-4">
              <div style={{ paddingBottom: 15 }}>
                <Label>Országhívó:</Label>
                <SelectInput
                  name="formOrszagHivo"
                  components={{ Option }}
                  isSearchable={true}
                  onChange={v => setOrszagHivo(v)}
                  placeholder="Válassz országot..."
                  getOptionLabel={option => option.caption}
                  getOptionValue={option => option.num}
                  options={orszagHivoOptions}
                  value={formOrszagHivo}
                  isClearable
                />
              </div>
            </div>
              <div className="col-md-4">
                <RFField
                  label="Telefonszám: "
                  name={"formTelefonszam"}
                  value={formTelefonszam}
                  onChange={e => setTelefonszam(e.target.value)}
                  //disabled={isDisabledTulajdonos()}
                  required={isRequiredTulajdonos("telefon")}
                />
              </div>
            </React.Fragment>
          )}
          {isVisibleTulajdonos("email") && (
            <div className="col-md-12">
              <RFField
                label="Email: "
                name={"formEmail"}
                value={formEmail}
                onChange={e => setEmail(e.target.value)}
                //disabled={isDisabledTulajdonos()}
                required={isRequiredTulajdonos("email")}
              />
            </div>
          )}
          </div>
      </React.Fragment>
    );
  }

  return (
    <Modal isOpen backdrop="static" size='md'>
      <RFForm
        modal
        onSubmit={savePartner}
        title="Új partner hozzáadása"
        footer={
          <>
            <ProgressButton type="submit" color="primary" loading={loading}>Kiválaszt</ProgressButton>
            <Button type="button" color="secondary" onClick={() => {
              toggleShowTulajdonosForm(false);
              setPartnerResponse(null);
              }
            }>Mégsem</Button>
          </>
        }
      >
        <div className="row">
          <div className="col-md-12">
            {renderForm()}
          </div>
        </div>
      </RFForm>
    </Modal>
  );
}

export default PartnerForm;